import type { ComponentProps } from 'react';

type NitroLogoProps = ComponentProps<'svg'> & {
  readonly colors?: [string, string];
};

const NitroLogo = ({ colors, ...props }: NitroLogoProps) => {
  return (
    <svg viewBox="0 0 63 15" focusable="false" role="img" {...props}>
      <title>NITRO</title>
      <path
        fill={colors?.[0] ?? '#e6e6e6'}
        d="M0 0V14.9814H3.41697V5.34653L9.17962 14.9629H12.4119V0H8.99493V9.61631L3.23226 0H0ZM14.4067 0V14.9814H18.1931V0H14.4067ZM19.6337 0V3.23019H22.6074V14.9629H26.3937V3.23019H29.3674V0H19.6337ZM30.6049 0V14.9814L34.3913 15V3.32302H38.1961C39.3411 3.32302 40.2649 4.26979 40.2649 5.4579C40.2649 6.64601 39.3411 7.57425 38.1961 7.57425H34.7422L39.9694 14.9629H44.2913L40.3757 10.0062C42.518 9.44925 44.1067 7.46288 44.1067 5.08662C44.1067 2.26485 41.8901 0 39.1564 0H30.6049ZM52.2148 0C48.0406 0 44.6607 3.36015 44.6607 7.48144C44.6607 11.6027 48.0406 14.9629 52.2148 14.9629C56.3894 14.9629 59.7692 11.6027 59.7692 7.48144C59.7692 3.36015 56.3894 0 52.2148 0ZM52.2148 3.30445C54.3944 3.30445 56.1674 5.17947 56.1674 7.48144C56.1674 9.78341 54.3944 11.6399 52.2148 11.6399C50.0355 11.6399 48.2622 9.78341 48.2622 7.48144C48.2622 5.17947 50.0355 3.30445 52.2148 3.30445Z"
      />
      <path fill={colors?.[1] ?? '#b8e637'} d="M63 11.751H59.7678V14.9998H63V11.751Z" />
    </svg>
  );
};

export default NitroLogo;
